import type { User } from '../types/user.dto';
import type { UserModel } from '../types/users.model';

export const toUserModel = (data: User): UserModel => {
	return {
		id: data.id!,
		organizationId: data.org_id!,
		email: data.email,
		firstName: data.firstname,
		lastName: data.lastname,
		accessLevel: data.access_level,
		isOnline: data.is_online,
		type: data.type,
	};
};
